import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import Bedroom from './Bedroom';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { postAPI_Create_Room, gAPI_QuestionOptionList } from '../../../../../constants/APIs';
import Select from "react-select";
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
const AddRoomForm = ({ visible, toggle, room, propertyId, locale }) => {
  const [roomData, setRoomData] = useState({
    type: '',
    numberRoomsInProperty: 0,
    nameStatements: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    descriptionStatements: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    standardCapacity: 0,
    minimumAdults: 0,
    maximumAdults: 0,
    maximumChildren: 0,
    maximumInfants: 0,
    extraBedsAllowed: false,
    numberBedrooms: 0,
    numberLivingRooms: 0,
    measurementUnit: 'sqmt',
    floorSize: 0,
    balconyArea: 0,
    bedArrangements: [
      {
        name: 'Arrangment',
        beds: [],
      },
    ],
    creator: 'bmbdashboard',
    displayOrder: 1,
    bookingUrl: [
      {
        statement: '',
        languageCode: locale,
      },
    ],
    searchTags: [],
  });
  const [isAddBedroom, setIsAddBedroom] = useState(false);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const handleAddFields = () => {
    const values = [...roomData.bedArrangements];
    values.push({
      name: 'Arrangment',
      beds: [],
    });
    setRoomData({ ...roomData, bedArrangements: values });
  };
  const handleRemoveBedRooms = index => {
    const values = [...roomData.bedArrangements];
    values.splice(index, 1);
    setRoomData({ ...roomData, bedArrangements: values });
  };
  const initBed = {
    beds: [
      {
        type: '',
        count: '',
      },
    ],
  };

  const tryParseInt = (str, defaultValue) => {
    var retValue = defaultValue;
    if (str !== null) {
      if (str.length > 0) {
        if (!isNaN(str)) {
          retValue = parseInt(str);
        }
      }
    }
    return retValue;
  };

  const handleChange = e => {
    e.persist();

    if (
      e.target.name === 'nameStatements' ||
      e.target.name === 'descriptionStatements' ||
      e.target.name === 'bookingUrl'
    ) {
      setRoomData({
        ...roomData,
        [e.target.name]: [
          {
            statement: e.target.value,
            languageCode: locale,
          },
        ],
      });
    } else {
      const value =
        tryParseInt(e.target.value, 0) === 0
          ? e.target.value
          : parseInt(e.target.value);
      if (e.target.name === 'extraBedsAllowed') {
        const extraBedAllowed = e.target.value ? true : false;
        setRoomData({ ...roomData, [e.target.name]: extraBedAllowed });
      } else {
        setRoomData({ ...roomData, [e.target.name]: value });
      }
    }
  };

  const handleSaveRoom = async () => {
    let data = roomData;
    //data = data['creator'] = 'Test';
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_Room}/${propertyId}`,
      data: data,
    })
      .then(res => {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      })
      .catch(err => {
        console.log('err', err);
      });
  };


  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Rooms`,
    })
      .then(res => {
        var options = [];
        try {
          res.data.map(
            (item) => options.push({ label: item.option, value: item.option, key: item.id })
          )
        }
        finally { }
        setTags(options);
      })
      .catch(err => console.log('err', err));

  }, []);
  const handleChangeTags = selectedTags => {
    setselectedTags(selectedTags);
    const tagsArr = selectedTags
      .map(elem => elem.value);

    setRoomData({
      ...roomData,
      searchTags: tagsArr
    });
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
        <ModalHeader toggle={toggle}>Add Room</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <Form>
                {/* <pre>{JSON.stringify(roomData, null, 2)}</pre> */}
                <FormGroup row>
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label for="type">
                        {/* <IntlMessages id="forms.email" /> */}
                        Room type
                      </Label>

                      <Input
                        type="select"
                        onChange={handleChange}
                        name="type"
                        id="type"
                      >
                        <option value="">Choose Room Type</option>
                        <option value="Accommodation">Accommodation</option>
                        <option value="Apartment">Apartment</option>
                        <option value="Bed in Dormitory">
                          Bed in Dormitory
                              </option>
                        <option value="Bungalow">Bungalow</option>
                        <option value="Cabin">Cabin</option>
                        <option value="Caravan Site">Caravan Site</option>
                        <option value="Chalet">Chalet</option>
                        <option value="Dormitory room">
                          Dormitory Room
                              </option>
                        <option value="Double">Double</option>
                        <option value="Family">Family</option>
                        <option value="Family Unit">Family Unit</option>
                        <option value="Holiday home">Holiday Home</option>
                        <option value="House">House</option>
                        <option value="Mobile home">Mobile Home</option>
                        <option value="Motel Unit">Motel Unit</option>
                        <option value="Non Powered Site">Non Powered Site</option>
                        <option value="Other Unit (homesstead, villa etc)">Other Unit (homesstead, villa etc)</option>
                        <option value="Powered Site">Powered Site</option>
                        <option value="Quadruple">Quadruple</option>
                        <option value="Self Contained Unit">Self Contained Unit</option>
                        <option value="Single">Single</option>
                        <option value="Studio">Studio</option>
                        <option value="Suite">Suite</option>
                        <option value="Tent">Tent</option>
                        <option value="Tent Site (tent, yurt, teepee etc)">Tent Site (tent, yurt, teepee etc)</option>
                        <option value="Triple">Triple</option>
                        <option value="Twin">Twin</option>
                        <option value="Villa">Villa</option>
                      </Input>
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={6}>
                    <FormGroup>
                      <Label for="standardCapacity">
                        {/* <IntlMessages id="forms.password" /> */}
                        How many guests can stay in this room?
                      </Label>
                      <Input
                        type="number"
                        name="standardCapacity"
                        id="standardCapacity"
                        min={0}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label for="nameStatements">
                        {/* <IntlMessages id="forms.password" /> */}
                        Room name
                      </Label>
                      <Input
                        type="text"
                        name="nameStatements"
                        id="nameStatements"
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label for="numberRoomsInProperty">
                        {/* <IntlMessages id="forms.password" /> */}
                        Number of room (of this type)
                      </Label>
                      <Input
                        type="number"
                        name="numberRoomsInProperty"
                        id="numberRoomsInProperty"
                        min={0}
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={12}>
                    <FormGroup>
                      <Label for="descriptionStatement">
                        {/* <IntlMessages id="forms.password" /> */}
                        Description
                      </Label>
                      <Input
                        type="textarea"
                        name="descriptionStatements"
                        id="descriptionStatements"
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="numberBedrooms">
                        {/* <IntlMessages id="forms.password" /> */}
                        Number of bedrooms
                      </Label>
                      <Input
                        type="number"
                        name="numberBedrooms"
                        id="numberBedrooms"
                        min={0}
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="numberOfLivingrooms">
                        {/* <IntlMessages id="forms.password" /> */}
                        Number of livingrooms
                      </Label>
                      <Input
                        type="number"
                        name="numberLivingRooms"
                        id="numberLivingRooms"
                        min={0}
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        Minimum Adults
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="minimumAdults"
                        id="minimumAdults"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        Maximum Adults
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="maximumAdults"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        Maximum Children
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="maximumChildren"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        Maximum Infants
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="maximumInfants"
                        id="maximumInfants"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label>
                        <Input
                          type="checkbox"
                          name="extraBedsAllowed"
                          id="extraBedsAllowed"
                          onChange={handleChange}
                        />
                        Extra Beds Allowed
                      </Label>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="floorSize">
                        {/* <IntlMessages id="forms.password" /> */}
                        Room size
                      </Label>
                      <InputGroup>
                        <Input
                          type="number"
                          name="floorSize"
                          id="floorSize"
                          onChange={handleChange}
                        />
                        <InputGroupAddon addonType="append"></InputGroupAddon>
                      </InputGroup>
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        Balcony Area
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="number"
                        name="balconyArea"
                        onChange={handleChange}
                      ></Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label>
                        Unit
                        {/* <IntlMessages id="forms.state" /> */}
                      </Label>
                      <Input
                        type="select"
                        onChange={handleChange}
                        name="measurementUnit"
                        id="measurementUnit"
                      >
                        <option value="Sqmt">square meters</option>
                        <option value="Sqft">square feet</option>
                      </Input>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="displayOrder">
                        {/* <IntlMessages id="forms.password" /> */}
                        Display Order
                      </Label>
                      <Input
                        type="number"
                        name="displayOrder"
                        id="displayOrder"
                        min={0}
                        onChange={handleChange}
                      //   placeholder={messages['forms.password']}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={12}>
                    <FormGroup>
                      <Label for="bookingUrl">
                        Booking URL
                      </Label>
                      <Input
                        type="text"
                        name="bookingUrl"
                        id="bookingUrl"
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={12}>
                    <FormGroup>
                      <Label for="bookingUrl">
                        Search Tags
                      </Label>
                      <Select
                        components={{ Input: CustomSelectInput }}
                        className="react-select"
                        classNamePrefix="react-select"
                        isMulti={true}
                        name="form-field-name"
                        value={selectedTags}
                        onChange={handleChangeTags}
                        options={tags}
                      />
                    </FormGroup>
                  </Colxx>



                </FormGroup>
              </Form>
            </Colxx>
          </Row>
          {roomData.bedArrangements.map((oneBedroom, index) => {
            return (
              <Fragment key={index}>
                <Bedroom
                  oneBedroom={oneBedroom}
                  isAddBedroom={false}
                  roomData={roomData}
                  setRoomData={setRoomData}
                  handleRemoveBedRooms={handleRemoveBedRooms}
                  roomindex={index}
                />
              </Fragment>
            );
          })}
          {/* {isAddBedroom && (
            <Bedroom
              oneBedroom={initBed}
              isAddBedroom={isAddBedroom}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          )} */}
          <Row>
            <Colxx xxs="12">
              <Button
                color="primary"
                outline
                size="lg"
                onClick={handleAddFields}
                style={{ width: '100%', borderRadius: '6px' }}
              >
                + Add Bedroom
              </Button>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSaveRoom}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};
export default injectIntl(connect(mapStateToProps)(AddRoomForm));